import {
  WALLET_ADDRESS,
  WALLET_ONBOARDING,
  WALLET_LIST,
  WALLET_CONNECT,
  CALL_WALLID_METHOD,
  INITIATE_PLUGIN,
  WALLID_EXPORT,
  WALLET_SIGN,
} from './walletConsts';
import { GET_TOKEN_WALLID } from '../consts';

var walletStore = require('debug')('iframe:walletStore');
var walletError = require('debug')('iframe:walletError');

const state = {
  walletAddress: null,
  isOnboardingComplete: false,
  hasPlugin: null,
  currentAssets: null,
  profile: null,
};

const getters = {
  walletAddress: (state) => state.walletAddress,
  isOnboardingComplete: (state) => state.isOnboardingComplete,
};

const actions = {
  // Calls all of required plugin methods to start the iframe
  //methods: connect, address, list['identities', 'profiles']
  [INITIATE_PLUGIN]: async ({ dispatch, state }) => {
    walletStore('Action INITIATE_PLUGIN');

    if (state.walletAddress) return;

    try {
      await dispatch(WALLET_ONBOARDING);
      if (state.isOnboardingComplete) {
        // await dispatch(WALLET_CONNECT);
        let { err } = await dispatch(WALLET_ADDRESS);
        if (err === 'ERR_PLUGIN_LOCKED' || err === 'ERR_NO_PERMISSION') {
          await dispatch(WALLET_CONNECT);
        }
        await dispatch(WALLET_ADDRESS);
      }
    } catch (err) {
      walletError('INITIATE_PLUGIN', err);
      return err;
    }
  },
  [CALL_WALLID_METHOD]: (_, { method, params }) => {
    walletStore('Action CALL_WALLID_METHOD', method, params);

    return new Promise((resolve, reject) => {
      try {
        window
          .wallid(method, params)
          .then((res) => {
            walletStore('CALL_WALLID_METHOD response', res);
            resolve(res);
            //   this.checkWallet();
          })
          .catch((err) => {
            walletError(err);
            reject(err);
          });
      } catch (err) {
        walletError('CALL_WALLID_METHOD', err);
        reject(err);
      }
    });
  },

  [WALLET_SIGN]: ({ dispatch }, { dataToSign }) => {
    walletStore('Action WALLET_SIGN');

    return new Promise((resolve, reject) => {
      try {
        resolve(
          dispatch(CALL_WALLID_METHOD, {
            method: WALLET_SIGN,
            params: [dataToSign],
          })
        );
      } catch (err) {
        walletError(err);
        reject(err);
      }
    });
  },

  [WALLET_CONNECT]: ({ dispatch }) => {
    walletStore('Action wallid_connect');

    return new Promise((resolve, reject) => {
      try {
        resolve(
          dispatch(CALL_WALLID_METHOD, {
            method: WALLET_CONNECT,
            params: { level: 2 },
          })
        );
      } catch (err) {
        walletError(err);
        reject(err);
      }
    });
  },
  [WALLET_ADDRESS]: ({ commit, dispatch }) => {
    walletStore('Action wallet_address');

    return new Promise((resolve, reject) => {
      try {
        dispatch(CALL_WALLID_METHOD, { method: WALLET_ADDRESS })
          .then((res) => {
            walletStore('WALLET_ADDRESS res: ', res);
            commit('walletAddress', res);
            resolve(res);
            //   this.checkWallet();
          })
          .catch((err) => {
            walletError('WALLET_ADDRESS', err);

            if (err === 'ERR_PLUGIN_LOCKED') {
              resolve({ isLocked: true, err });
            }
            if (err === 'ERR_NO_PERMISSION') {
              resolve({ notConnected: true, err });
            }

            reject(err);
          });
      } catch (err) {
        walletError('WALLET_ADDRESS', err);
        reject(err);
      }
    });
  },
  // [WALLET_LIST]: ({ commit, dispatch }) => {
  //   walletStore('Action getIdentitiesPlugin wallid_identities');

  //   return new Promise((resolve, reject) => {
  //     try {
  //       dispatch(CALL_WALLID_METHOD, {
  //         method: WALLET_LIST,
  //       })
  //         .then((res) => {
  //           walletStore('WALLET_LIST res: ', res);
  //           commit('currentAssets', { identities: res });
  //           resolve({ identities: res });
  //         })
  //         .catch((err) => {
  //           walletError(err);
  //           reject(err);
  //         });
  //     } catch (err) {
  //       walletError(err);
  //       reject(err);
  //     }
  //   });
  // },
  // new version of plugin is required ^1.1.xx
  [WALLET_LIST]: ({ commit, dispatch }) => {
    walletStore('Action getIdentitiesPlugin wallid_list');

    return new Promise((resolve, reject) => {
      try {
        dispatch(CALL_WALLID_METHOD, {
          method: WALLET_LIST,
          params: [['identities', 'profiles', 'credentials']],
        })
          .then((res) => {
            walletStore('WALLET_LIST res: ', res);
            commit('currentAssets', res);
            resolve(res);
          })
          .catch((err) => {
            walletError(err);
            resolve(err);
          });
      } catch (err) {
        walletError(err);
        reject(err);
      }
    });
  },
  // new version of plugin is required ^1.1.xx
  [WALLID_EXPORT]: ({ commit, dispatch }, { type, idt }) => {
    walletStore('Action getWalletAsset wallid_export_asset');

    return new Promise((resolve, reject) => {
      try {
        dispatch(CALL_WALLID_METHOD, {
          method: WALLID_EXPORT,
          params: [type, idt], // {type, idt}
        })
          .then((res) => {
            walletStore('WALLID_EXPORT res: ', res);
            commit('selectedAsset', res, { root: true });
            resolve(res);
          })
          .catch((err) => {
            walletError(err);
            reject(err);
          });
      } catch (err) {
        walletError(err);
        reject(err);
      }
    });
  },
  [WALLET_ONBOARDING]: ({ commit, dispatch }) => {
    walletStore('Action getOnboardingComplete wallid_onboarding');
    return new Promise((resolve, reject) => {
      try {
        dispatch(CALL_WALLID_METHOD, { method: WALLET_ONBOARDING })
          .then((res) => {
            walletStore('WALLET_ONBOARDING res: ', res);
            commit('isOnboardingComplete', res.initialized);

            resolve(res.initialized);
          })
          .catch((err) => {
            walletError(err);
            reject(err);
          });
      } catch (err) {
        walletError(err);
        reject(err);
      }
    });
  },

  [GET_TOKEN_WALLID]: ({ state }, { operation, idt }) => {
    walletStore('GET_TOKEN Action');

    return new Promise((resolve, reject) => {
      if (state.idt == idt) {
        console.log(state.idt);
      }
      window
        .wallid('wallid_token', [idt.value, operation])
        .then((res) => {
          console.log(res);
          resolve(res);
        })
        .catch((err) => {
          console.error(err);
          reject(err);
        });
    });
  },
  IMPORT_ONLINE_ID({ state }, { username }) {
    return new Promise((resolve, reject) => {
      try {
        const profileData = arguments[1];
        console.log(profileData);
        window
          .wallid('wallid_import_social_profile', [
            state.profile.socialName + username,
            profileData,
            username,
            state.profile.socialName,
            true, // ow
          ])
          .then((res) => {
            console.log(' Import URL', res);
            localStorage.setItem('hasIdentities', 'true');
            resolve({
              id: state.profile.socialName + username,
              profileData,
              username,
              socialName: state.profile.socialName,
            });
          })
          .catch((err) => {
            console.log(err);
            reject(new Error('Fail to import Data'));
          });
      } catch (err) {
        console.log(err);
        reject(new Error('Fail to import Data' + err));
      }
    });
  },
};

const mutations = {
  walletAddress: (state, value) => {
    state.walletAddress = value;
  },
  isOnboardingComplete(state, value) {
    state.isOnboardingComplete = value;
  },
  hasPlugin(state, value) {
    state.hasPlugin = value;
  },
  currentAssets(state, value) {
    state.currentAssets = value;
  },
  profile: (state, newValue) => {
    state.profile = newValue;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
